const toggleList = (e) => {
    const module = e.currentTarget.closest('.tabbed-content-1800');
    const list = module.querySelector('.tabbed-content-1800__wrapper__left-nav__list');//this is tab list that appears on left in desktop screen
    const listButton = module.querySelector('.tabbed-content-1800__wrapper__left-nav__btn'); //this is the dropdown visible in smaller screens

    list.classList.toggle('active');
    listButton.classList.toggle('active');
}

const tabClick = (e) => {
    if (e.keyCode === 32 && document.querySelector('.experience-editor') != null) {//do nothing in EE
        e.preventDefault();
    } 
    const dataId = e.currentTarget.getAttribute('data-id');//get tab id
    const module = e.currentTarget.closest('.tabbed-content-1800');
    module.querySelectorAll('.tabbed-content-1800__wrapper__left-nav__list__item').forEach(t => {//get all tabs
        t.classList.remove('active');//mark tabs inactive
        t.setAttribute('aria-selected', false);//mark tabs not selected
        t.setAttribute('tabindex', 0);//mark tab index as 0
    });
    e.currentTarget.classList.add('active');//mark clicked tab element active
    module.querySelectorAll('.tabbed-content-1800__wrapper__content').forEach(t => {//get all tab contents
        t.classList.remove('in');
        t.setAttribute('aria-hidden', true);//hide all
        t.setAttribute('tabindex', -1);
    });
    document.getElementById(dataId).classList.add('in');//show content related to clicked tab

    const list = module.querySelector('.tabbed-content-1800__wrapper__left-nav__list');//this is tab list that appears on left in desktop screen
    const listButton = module.querySelector('.tabbed-content-1800__wrapper__left-nav__btn'); //this is the dropdown visible in smaller screens

    list.classList.remove('active');
    listButton.classList.remove('active');
    tabStatus(module, listButton);
    resortTabIndex(module);
};

const tabStatus = (module, listButton) => {
    let activeTab = module.querySelector('.tabbed-content-1800__wrapper__left-nav__list__item.active');//get the active tab
    let activeContent = module.querySelector('.tabbed-content-1800__wrapper__content.in');//get the content area of active tab
    activeContent.setAttribute('aria-hidden', false);//mark content as not hidden
    activeTab.setAttribute('aria-selected', true);//mark tab as selected
    let targetLabel = activeTab.textContent;//get selected tab label
    let targetIcon = activeTab.querySelector('svg');//get selected tab icon
    if (targetIcon) {//setting the listbutton innher html for smaller screens
        listButton.innerHTML = '<span class="tabbed-content-1800__wrapper__left-nav__btn__icon">' + targetIcon.outerHTML + '</span>' + targetLabel;
    }
    else {
        listButton.innerHTML = targetLabel;
    }
}

const resortTabIndex = (module) => {
    let activeTab = module.querySelector('.tabbed-content-1800__wrapper__left-nav__list__item.active');//get active tab
    let activeContent = module.querySelector('.tabbed-content-1800__wrapper__content.in');//get active content
    activeTab.setAttribute('tabindex', 1);
    activeContent.setAttribute('tabindex', 1);
    let activeLinks = module.querySelectorAll('.tabbed-content-1800__wrapper__content.in a');//get all links within active content
    activeLinks.forEach(z => {
        z.setAttribute('tabindex', 1);
    });
}

const bindTabs = (module, list, listButton) => {
    module.querySelectorAll('.tabbed-content-1800__wrapper__left-nav__list__item').forEach(tab => { //get all tabs 
        tab.addEventListener('click', tabClick);//add event on each tab
        tab.addEventListener('keyup', tabClick);
    })
};

document.querySelectorAll('.tabbed-content-1800').forEach(module => { //look for each 1800 module
    
    const list = module.querySelector('.tabbed-content-1800__wrapper__left-nav__list');//this is tab list that appears on left in desktop screen
    const listButton = module.querySelector('.tabbed-content-1800__wrapper__left-nav__btn'); //this is the dropdown visible in smaller screens
    listButton.addEventListener('click', toggleList);//on click of dropdown, exexute toggle on tabs

    tabStatus(module, listButton);
    resortTabIndex(module);
    bindTabs(module, list, listButton);
});